module.exports = __webpack_public_path__ + "img/LTS_CI.28d2dc55.gif";